
module.exports = {
	/* DatePicker */
	dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
	dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
	dayNamesShort: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
	monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août' , 'Septembre', 'Octobre', 'Novembre' , 'Décembre'],
	monthNamesShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jui', 'Jui', 'Aoû' , 'Sep', 'Oct', 'Nov' , 'Déc'],

	/* Header Cart */
	"cart": "Panier",
	"product": "produit",
	"product_plural": "produits",

	/* Header Favs */
	"favorite": "favori",
	"favorite_plural": "favoris",

	/* Collectible */
	"collectible.results": "Résultat",
	"collectible.of": "de",
	"next": "suivant",
	"prev": "précédent",
	"remove": "vider",

	/* SortOrderTemplate */
	sort_auto: "actuel",
	sort_stars: "étoiles",
	sort_ratings: "avis",
	sort_price: "prix",

	/* SidebarTemplate */
	sidebar_more: "plus",

	/* result-template */
	result_validated: "Qualité vérifiée",
	result_book_online: "réservation en ligne",
	like: "J´aime",
	unlike: "Je n´aime pas",
	result_recommentation: "recommandation",
	add_spa_tax: "plus taxe de séjour",
	recommentation: "recommandation",

	/* result-error */
	result_error_title: "La recherche est erronée",
	result_error_subtitle: "Il y a un problème avec votre demande:",
	reset_search: "Annuler la recherche",

	/* no-results */
	no_result_title: "Hôte “{searchQuery}“ pas trouvé",
	no_result_match: "Aucun hôte trouvé selon vos critères.",

	favsonly_empty_title: "Aucun résultat trouvé",
	favsonly_empty_text: "Aucun résultat avec les critères selectionnés",

	/* loader-results */
	loading_text: "résultats en cours de téléchargement",

	/* datepicker-item-info */
	datepicker_item_tip: "Conseil: cliques en 1er sur la date d´arrivée puis sur la date de départ",
	datepicker_item_selected: "sorti par dates d´arrivée pour »{name}«",

	/* datepicker-controls */
	dp_controls_mode_none: "Aucune",
	dp_controls_mode_exact: "Exacte",
	dp_controls_mode_range: "Flexible",
	dp_controls_from: "du",
	dp_controls_to: "au",
	date_to: "-",

	/* engine/main.js */
	dd_selected_none: "Dates",
	dd_select_date: "Dates de séjour",
	dd_select_date_short: "Dates de séjour",

	favorites: "Favoris",
	one_favorite: "1 favoris",

	/* FormModel.js */
	people_any_count: "Personnes",

	housing_any: "Chambre / Appartement",
	housing_room: "Chambre",
	housing_single: "Chambre simple",
	housing_double: "Chambre double",
	housing_flat: "Appartement",
	housing_house: "Maison / Chalet",
	housing_campsite: "Parking",

	bedroom_count: "Num. chambres",
	bedroom: "chambre",
	bedrooms: "chambres",

	adult: "adulte",
	adults: "adultes",
	no_adults: "Pas d´ adultes",
	child: "enfant",

	no_children: "Pas d´ enfant",
	one_child: "1 enfant",
	children: "enfants",

	housings: "housings",


	/* NightsCompressor.js */
	night: "nuit",
	nights: "nuits",
	at_least: "min.",
	nights_list: "{nights} et {last_item} nuits",

	/* timetable-template */
	today: "today",

	/* ratings-template */
	add_rating: "Bewertung schreiben",

	rating_1: "Offre",
	rating_2: "Propreté",
	rating_3: "Gentillesse",
	rating_4: "Je recommande",

	age: "Âge",
	no_ratings: "Dommage, aucun avis trouvé",

	for_one_week: "pour 1 semaine",
	for_two_weeks: "pour 2 semaines",
	for_x_days: "pour {days} hours",

	in_winter: "en hiver",
	in_spring: "au printemps",
	in_summer: "en été",
	in_autumn: "en automne",
	rated_on: "commenté le",
	age_range: "{from} jusqu´en {to} année",

	"traveled_as_Single": "Voyage tout seul",
	"traveled_as_Paar": "Voyage en couple",
	"traveled_as_Familie": "Voyage en famille",
	"traveled_as_Freunde": "Voyage avec des amis",
	products_and_services: "produits &amp; services",

	/* DateTime.js */
	no_date: "Dates",
	one_night: "1 nuit",
	x_nights: "{nights} nuits",

	/* classes-template */
	item_focused: "Forfait",
	order: "Réserver maintenant",
	inquiry: "Demande de réservation",
	total_price: "Prix total",
	price_no_query: "Prix selon dates et nombre de personnes",
	search: "Chercher",
	packages: "Offres",
	package: "Offre",

	results_404_title: "pas de catégorie trouvée",
	results_404_prefix: "Changer les critères ou",
	results_404_link: "chercher sans dates",
	price_from: "À partir",

	/* cart-items-template */
	cart_empty: "La corbeille est vide",
};




/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/reserva/translate/lang.fr.js
 **/